<template>
    <div class="container">

        <nav aria-label="breadcrumb" class=" container d-block mt-3">
            <ul class="d-flex list-unstyled flex-wrap" style="gap:.3rem;">
                <li><a class="pdv-thumbnail-color" href="/"><span class="icon-ui icon-home"></span> {{__('messages.home')}}</a></li>
                <li>></li>
                <li><a class="pdv-thumbnail-color" href="/puntos-de-venta">{{__('messages.select_atention')}}</a></li>
                <li v-if="location">></li>
                <li v-if="location" > <a class="pdv-thumbnail-color" :href="'/puntos-de-venta/' + location.uri">{{ location.name }} </a></li>
                <li v-if="place">></li>
                <li v-if="place" > <a class="pdv-thumbnail-color" :href="'/puntos-de-venta/' + place.uri">{{ place.displayName }} </a> </li>
            </ul>
        </nav>

    </div>
</template>

<script>
export default {
    props: {
        pdvs: Object,
    },
    data() {
        return {
            place: null,
            location: null
        };
    },
    mounted() {
        if (this.pdvs) {
            if (this.pdvs.dispatch.path) {
                this.place = this.pdvs.branchs.find(elem => elem.uri === this.pdvs.dispatch.path);

                if (this.place) {
                    this.location = {
                        name: this.place.stateName,
                        uri: this.place.stateName.toLocaleLowerCase().split(' ').join('-')
                    }
                    this.location.uri = this.location.uri.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                } else {
                    this.location = this.pdvs.states.find(elem => elem.uri === this.pdvs.dispatch.path);
                }
            }
        }
    }
};
</script>